import { Box, Card, CardContent, Typography } from '@mui/material';

export const KPI_CARD_SX = { height: '100%', width: '100%', backgroundColor: '#f9f9f9' };

export const STAT_CARD_GRID_4_SX = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    lg: 'repeat(4, minmax(0, 1fr))',
  },
  gap: 2,
  mb: 1,
};

export const STAT_CARD_GRID_2_SX = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    lg: 'repeat(2, minmax(0, 1fr))',
  },
  gap: 2,
  mb: 1,
};

export const STAT_CARD_GRID_3_SX = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    lg: 'repeat(3, minmax(0, 1fr))',
  },
  gap: 2,
  mb: 1,
};

export const STAT_CARD_GRID_STREAKS_SX = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: {
    xs: 'repeat(2, minmax(0, 1fr))',
    sm: 'repeat(3, minmax(0, 1fr))',
    lg: 'repeat(5, minmax(0, 1fr))',
  },
  gap: 2,
  mb: 1,
};

export const ExportButtonSx = {
  backgroundColor: '#EFF3FE',
  color: 'black',
  borderRadius: '17px',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#E0E8FC',
    boxShadow: 'none',
  },
};

export const AnalyticsExportButtonSx = {
  textTransform: 'none',
  borderRadius: '17px',
};

export const DqStatCard = ({
  title,
  value,
  subtitle,
  icon = null,
  valueColor = 'primary.main',
  valueVariant = 'h4',
}) => (
  <Card sx={KPI_CARD_SX}>
    <CardContent>
      <Typography color="textSecondary" gutterBottom>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {icon}
        <Typography variant={valueVariant} color={valueColor} sx={{ fontWeight: 600 }}>
          {value ?? 0}
        </Typography>
      </Box>
      {subtitle ? (
        <Typography color="textSecondary" sx={{ mt: 1, fontSize: 14 }}>
          {subtitle}
        </Typography>
      ) : null}
    </CardContent>
  </Card>
);

export const SectionTitle = ({ children }) => (
  <Typography variant="h6" color="textSecondary" sx={{ mb: 1.5, mt: 2, fontWeight: 500 }}>
    {children}
  </Typography>
);
